import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { CountdownTimer } from '../CountdownTimer';
import { heroChecks, images } from '../../data/site';
export function Hero() {
  return <header className="relative overflow-hidden bg-navy text-white" data-id="element-178" data-mp="cv2yxhzy5o8z">
      <div className="bg-gold px-4 py-2 text-center font-display text-[12px] font-extrabold uppercase tracking-wide text-navy sm:text-sm" data-id="element-179" data-mp="hvh2amqlsa0o">
        Special Digital Release — Only $27 Today
      </div>

      <div className="mx-auto grid max-w-6xl items-center gap-8 px-4 pb-14 pt-8 md:grid-cols-[1.05fr_1fr] md:gap-12 md:px-8 md:pb-20 md:pt-14" data-id="element-180" data-mp="quubdeatewkv">
        <div className="text-center md:text-left" data-id="element-181" data-mp="vn46d8qsemu0">
          <p className="font-display text-sm font-extrabold tracking-wide text-sky sm:text-base" data-id="element-182" data-mp="10loy0jrz3y6u">
            DENTAL PREDICTABILITY ROADMAP™
          </p>
          <p className="mt-1 text-sm text-white/70" data-id="element-183" data-mp="15iff9afikztu">
            The Clinical Roadmap for More Predictable Clear Aligner Treatment Planning
          </p>
          <h1 className="mt-5 font-display text-[30px] font-black leading-[1.08] tracking-tight sm:text-4xl lg:text-[52px]" data-id="element-184" data-mp="9oube3kpl7zm">
            Stop Guessing Which Tooth Movements Will{' '}
            <span className="text-gold" data-id="element-185" data-mp="3vuhhx42a79rz">Actually Track</span>
          </h1>
          <p className="mt-3 font-display text-lg font-bold text-sky sm:text-xl" data-id="element-186" data-mp="3rtfgcgkw6lmu">
            Start Planning With Greater Clinical Confidence.
          </p>

          <img src={images.mockup} alt="Dental Predictability Roadmap collection: 6 clinical volumes and 5 bonuses" className="mx-auto mt-6 w-full max-w-md md:hidden" data-id="element-187" data-mp="sdskc7kofaeg" />

          <p className="mt-6 text-base leading-relaxed text-white/85 sm:text-lg" data-id="element-188" data-mp="imo3117j3dgg">
            Identify high-risk tooth movements before treatment begins, understand their biomechanical limitations, and build more predictable clear aligner treatment plans with a practical, step-by-step clinical roadmap.
          </p>
          <p className="mt-4 text-[15px] leading-relaxed text-white/70" data-id="element-189" data-mp="16c8p3syzaqty">
            I’ve brought together <strong className="text-white" data-id="element-190" data-mp="30o9vkn4v6l9r">six specialized clinical guides</strong> and{' '}
            <strong className="text-white" data-id="element-191" data-mp="35n36c7srny68">five practical planning tools</strong> to help you recognize movement-related risks, evaluate treatment setups, and make better-informed decisions throughout your clear aligner cases.
          </p>
          <p className="mt-5 font-display text-base font-extrabold text-white" data-id="element-192" data-mp="2huwhruta8vhd">
            Know what to evaluate. Understand what can go wrong. <span className="text-gold" data-id="element-193" data-mp="2mw3r3yb2q2q5">Plan with greater confidence.</span>
          </p>

          <div className="mt-7 flex flex-col items-center gap-5 md:items-start" data-id="element-194" data-mp="27yjouz5kalno">
            <CtaButton id="first-cta" label="Get the Roadmap — $27" data-id="element-195" data-mp="2cvjmclocig36" />
            <CountdownTimer data-id="element-196" data-mp="65vhcdlvxc23" />
          </div>

          <ul className="mx-auto mt-7 grid max-w-md grid-cols-1 gap-2 text-left sm:grid-cols-2 md:mx-0 md:max-w-none" data-id="element-197" data-mp="676l4dfbyjt7">
            {heroChecks.map(c => <li key={c} className="flex items-start gap-2 text-[13px] font-medium text-white/85" data-id="element-198" data-mp="1vmr1i7ughpta">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-sky" aria-hidden="true" data-id="element-199" data-mp="1qo7gc9nosi1z" />
                {c}
              </li>)}
          </ul>
        </div>

        <div className="hidden md:block" data-id="element-200" data-mp="25en1xpk0ls0o">
          <img src={images.mockup} alt="Dental Predictability Roadmap collection: 6 clinical volumes and 5 bonuses" className="w-full" data-id="element-201" data-mp="20ltvmx8webmh" />
        </div>
      </div>
    </header>;
}